import { useMediaLibraryLanguage, mlText } from "../i18n/mediaLibraryPresentation";

import { Link } from "react-router";
import { Card } from "../components/ui/Card";

export const ForbiddenPage = () => { useMediaLibraryLanguage(); return (
  <div className="space-y-6">
    <div>
      <h1 className="text-xl sm:text-2xl font-semibold min-w-0 break-words hyphens-auto">{mlText("accessRestricted")}</h1>
      <p className="text-sm text-muted-foreground">
        {mlText("youDoNotHavePermissionToViewThisPage")}</p>
    </div>
    <Card title={mlText("needAccess")} description={mlText("contactAnAdministratorToRequestPermissions")}>
      <Link to="/profile" className="text-sm font-semibold text-primary-text hover:underline">
        {mlText("returnToProfile")}</Link>
    </Card>
  </div>
); };
